// api/serviceCategoryService.js
import apiClient from '../../../api/apiClient';

export const fetchServiceCategories = async () => {
  try {
    const response = await apiClient.get('/service-categories');
    return response.data;
  } catch (error) {
    console.error("Error fetching service categories:", error);
    throw new Error("Failed to fetch service categories");
  }
};

export const createServiceCategory = async (categoryData) => {
  try {
    const response = await apiClient.post('/service-categories', categoryData);
    return response.data;
  } catch (error) {
    console.error("Error creating service category:", error);
    throw new Error("Failed to create service category");
  }
};